module.exports = __webpack_public_path__ + "media/medium.bdac7398.mp3";